import Platform from "../../../../libs/utility/Platform";
import { Theme } from "../../../components/constants";

export default {
    gridColumnText: {
		fontSize: "16px",
		color: Theme.TEXT_PRIMARY_BLACK,
		whiteSpace: 'pre'
	},
    mainTitle: {
        marginBottom: "20px",
        color: Theme.PRIMARY,
        marginTop:"10px"
    },
    selectReportingCompanytitle: {
        marginBottom: "20px",
        color: Theme.TEXT_DARK_GRAY,
    },
    gridActions: { 
        display: 'flex', 
        gap: '10px' 
    },
    addBtnDiv: {
        display: "flex",
        justifyContent: "space-between",
    },
    addBtnStyles: {
        height: "fit-content",
    },
    privacyActContainer: {
        padding: "20px", 
    },
    accordionHeader: {
        background: Theme.DISABLED_INPUT,
        border: "none",
    },
    reviewMainContainer: {
        display: "flex",
        flexDirection: "column",
        width: Platform.isMobileView() ? "100%" : "70%",
    },
    reviewHeading: {
        marginBottom: "20px",
    },
    helpTextPopupStypes: {
        width: "80%", 
        maxWidth: "80%", 
        height: "80%"
    },
    helpTextPopupHeaderStyles: {
        border: "1px solid #ccc",
        padding: "5px 10px"
    },
    helpTextChildrenStyles: {
        padding: "20px",
        height: "100%",
    },
    headerStyle:{
        padding:"20px 0px 0px 0px"
    }
}